<template>
  <div>
    <el-card style="margin-top: 20px">
      <el-cascader
        :props="props"
        style="margin-left: 20px"
        :show-all-levels="false"
        v-model="cascaderValue"
        placeholder="请选择分类"
      ></el-cascader>
      <el-select
        v-model="GradeName"
        placeholder="请选择年级"
        style="margin-left: 20px"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-input
        v-model="NameTitle"
        placeholder="请输入文件名"
        style="margin-left: 20px; width: 200px"
      ></el-input>
      <el-button
        type="goon"
        style="margin-left: 20px"
        @click="GetBookInfoByPage"
        >查询</el-button
      >
      <el-button type="goon" style="margin-left: 20px" @click="onEmpty"
        >清空</el-button
      >
      <el-button type="goon" @click="dialogVisible = true">新增文件</el-button>
    </el-card>
    <el-card style="margin-top: 20px">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
          'text-align': 'center',
        }"
        border
      >
        <el-table-column prop="OneCateName" label="一级分类" align="center">
        </el-table-column>
        <el-table-column prop="TwoCateName" label="二级分类" align="center">
        </el-table-column>
        <el-table-column prop="ThreeCateName" label="三级分类" align="center">
        </el-table-column>
        <el-table-column prop="NameTitle" label="文件名称" align="center">
        </el-table-column>
        <el-table-column label="封面" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.Img"
              fit="cover"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="CreateTime" label="创建时间" align="center">
        </el-table-column>

        <el-table-column prop="address" label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="danger" @click="onClickDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="PageSize"
        :total="total"
        style="text-align: center;padding:20px; 0 0 0"
      >
      </el-pagination>
    </el-card>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <div>
        <el-form ref="form" :model="form" label-position="top">
          <el-form-item label="分类：">
            <el-cascader
              :props="formProps"
              :show-all-levels="false"
              v-model="form.ThreeId"
              placeholder="请选择分类"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="封面：">
            <el-upload
              class="avatar-uploader"
              action="/api/img/UploadImg"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="form.Img" :src="form.Img" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="文件上传：">
            <el-upload
              class="image-uploader"
              :multiple="false"
              :auto-upload="true"
              list-type="excel"
              :show-file-list="true"
              :drag="true"
              action
              :limit="1"
              :on-exceed="handleExceed"
              :before-upload="beforeUpload"
              :http-request="uploadFile"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或
                <em>点击上传</em>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="文件名称">
            <el-input v-model="form.NameTitle"></el-input>
          </el-form-item>
          <el-form-item label="年级名称">
            <el-select v-model="form.GradeName" placeholder="请选择年级">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onClickSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetBookCateOneInfo,
  GetBookCateTwoThreeInfo,
  GetBookInfoByPage,
  FileUploadsExcel,
  AddBookFileInfo,
  DeleteBookFileInfo,
} from "../../api/api";
export default {
  data() {
    return {
      tableData: [],
      total: 0,
      Title: "新增/编辑",
      props: {
        lazy: true,
        async lazyLoad(node, resolve) {
          const { level } = node;

          if (level === 0) {
            //一级选择器的生成
            let res = await GetBookCateOneInfo();
            if (res.data.success) {
              let nodes = Array.from(res.data.response).map((item) => ({
                value: item.Id,
                label: item.Name, // 生成列表 array.from可以研究研究 真的是好用
              }));

              resolve(nodes);
            } else {
              let nodes = {
                value: null,
                label: "暂无", // 生成列表 array.from可以研究研究 真的是好用
              };
              resolve(nodes);
            }
          } else if (level === 1) {
            let xhr = await GetBookCateTwoThreeInfo({ Id: node.data.value });

            if (xhr.data.success) {
              let nodes = Array.from(xhr.data.response).map((item) => ({
                value: item.Id,
                label: item.Name, // 生成列表 array.from可以研究研究 真的是好用
              }));

              resolve(nodes);
            } else {
              let nodes = {
                value: null,
                label: "暂无", // 生成列表 array.from可以研究研究 真的是好用
              };
              resolve(nodes);
            }
          } else if (level === 2) {
            let xhr = await GetBookCateTwoThreeInfo({ Id: node.data.value });
            //console.log(xhr.data.success);
            if (xhr.data.success) {
              let nodes = Array.from(xhr.data.response).map((item) => ({
                value: item.Id,
                label: item.Name, // 生成列表 array.from可以研究研究 真的是好用
                leaf: level >= 2,
              }));

              resolve(nodes);
            } else {
              //console.log(456);
              let nodes = {
                value: null,
                label: "暂无", // 生成列表 array.from可以研究研究 真的是好用
              };
              resolve(nodes);
            }
          }
        },
      },
      formProps: {
        lazy: true,
        async lazyLoad(node, resolve) {
          const { level } = node;

          if (level === 0) {
            //一级选择器的生成
            let res = await GetBookCateOneInfo();
            if (res.data.success) {
              let nodes = Array.from(res.data.response).map((item) => ({
                value: item.Id,
                label: item.Name, // 生成列表 array.from可以研究研究 真的是好用
              }));

              resolve(nodes);
            } else {
              let nodes = {
                value: null,
                label: "暂无", // 生成列表 array.from可以研究研究 真的是好用
              };
              resolve(nodes);
            }
          } else if (level === 1) {
            let xhr = await GetBookCateTwoThreeInfo({ Id: node.data.value });

            if (xhr.data.success) {
              let nodes = Array.from(xhr.data.response).map((item) => ({
                value: item.Id,
                label: item.Name, // 生成列表 array.from可以研究研究 真的是好用
              }));

              resolve(nodes);
            } else {
              let nodes = {
                value: null,
                label: "暂无", // 生成列表 array.from可以研究研究 真的是好用
              };
              resolve(nodes);
            }
          } else if (level === 2) {
            let xhr = await GetBookCateTwoThreeInfo({ Id: node.data.value });
            if (xhr.data.success) {
              let nodes = Array.from(xhr.data.response).map((item) => ({
                value: item.Id,
                label: item.Name, // 生成列表 array.from可以研究研究 真的是好用
                leaf: level >= 2,
              }));

              resolve(nodes);
            } else {
              //console.log(456);
              let nodes = {
                value: null,
                label: "暂无", // 生成列表 array.from可以研究研究 真的是好用
              };
              resolve(nodes);
            }
          }
        },
      },
      cascaderValue: [],
      PageIndex: 1,
      PageSize: 10,
      options: [
        {
          value: "小班",
          label: "小班",
        },
        {
          value: "中班",
          label: "中班",
        },
        {
          value: "大班",
          label: "大班",
        },
      ],
      GradeName: "",
      NameTitle: "",
      dialogVisible: false,
      form: {
        ThreeId: [],
        Img: "",
        Link: "",
        GradeName: "",
        NameTitle: "",
      },
    };
  },
  created() {
    this.GetBookInfoByPage();
  },
  methods: {
    async onClickDelete(item) {
      let res = await DeleteBookFileInfo({ id: item.FileId });
      if (res.data.success) {
        this.$message({
          type: "success",
          message: "删除成功",
        });
        this.GetBookInfoByPage();
      } else {
        this.$message({
          type: "error",
          message: "删除失败",
        });
      }
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetBookInfoByPage();
    },
    // 确定
    async onClickSubmit() {
      if (this.form.ThreeId[2]) {
        let res = await AddBookFileInfo({
          threeId: this.form.ThreeId[2],
          img: this.form.Img,
          link: this.form.Link,
          GradeName: this.form.GradeName,
          NameTitle: this.form.NameTitle,
        });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "新增成功",
          });
          this.GetBookInfoByPage();
          this.dialogVisible = false;
        }
      } else {
        this.$message({
          type: "error",
          message: "没有分类选项不可上传文件",
        });
      }
    },
    //导入
    uploadFile(item) {
      //console.log(item);
      //    //console.log(this.comId);
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      //    form.append("comId", this.comId);
      form.append("filetype", "excel");
      // //console.log(form);
      //debugger;
      FileUploadsExcel(form).then((res) => {
        this.form.Link = res.data.url;
        // //console.log(response);
        // //console.log(this.Link);
        this.$message.info("文件：" + fileObj.name + "上传成功");
      });
    },
    // 上传文件个数超过定义的数量
    handleExceed() {
      this.$message.warning(`当前限制选择 1 个文件，请删除后继续上传`);
    },
    beforeUpload(file) {
      //console.log("beforeUpload");
      // //console.log(file.type);
      const isText = file.type === "application/vnd.ms-excel";
      const isTextComputer =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      return isText | isTextComputer;
    },
    handleAvatarSuccess(res, file) {
      this.form.Img = res.response;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    async GetBookInfoByPage() {
      let res = await GetBookInfoByPage({
        OneCateId: this.cascaderValue[0],
        TwoCateId: this.cascaderValue[1],
        ThreeCateId: this.cascaderValue[2],
        NameTitle: this.NameTitle,
        GradeName: this.GradeName,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
      });
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    onEmpty() {
      this.GradeName = "";
      this.NameTitle = "";
      this.cascaderValue = [];
      this.GetBookInfoByPage();
    },
  },
};
</script>
<style lang="less" scoped>
.m-r {
  margin-right: 20px;
}
/deep/.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
/deep/.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
</style>